import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { setLoginInput, setPasswordInput, clearLoggedInUserData, setTwoFactorCode, setNeedToShowUserWarning, setNeedToLogout } from '../actions/localStates'

import logo from '../img/fon4_.svg'

class LoginView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	showPassword: false,
	    	secondsLeft: 0
	    }

	    this.onLoginChanged = this.onLoginChanged.bind(this);
	    this.onPasswordChanged = this.onPasswordChanged.bind(this);
	    this.logIn = this.logIn.bind(this);
	    this.keyUpHandler = this.keyUpHandler.bind(this, 'return');
	    this.handlePwdKeyUp = this.keyUpHandler.bind(this, 'PwdInput');

	    this.onTwoFactorCodeChanged = this.onTwoFactorCodeChanged.bind(this);
	    this.handleOneTimeCodeKeyUp = this.keyUpHandler.bind(this, 'oneTimeCodeInput');
	    this.logIn2f = this.logIn2f.bind(this);

	    this.startTimer = this.startTimer.bind(this)
	}

	componentDidMount() {
		document.addEventListener('keyup', this.keyUpHandler);
		this.props.actions.clearLoggedInUserData();
	}

	componentWillUnmount() {
		document.removeEventListener('keyup', this.keyUpHandler);
		clearInterval(this.timer);
	}

	componentDidUpdate(prevProps) {
	    // console.log(
	    //     "prev:", prevProps.codeTtl,
	    //     "curr:", this.props.codeTtl,
	    //     "seconds:", this.state.secondsLeft
	    // );

	    if (prevProps.codeTtl !== this.props.codeTtl) {
	        console.log("START");

	        this.setState(
	            { secondsLeft: this.props.codeTtl },
	            () => {
	                console.log("startTimer");
	                this.startTimer();
	            }
	        );
	    }
	}

	onLoginChanged (e) {
		this.props.actions.setLoginInput(e.target.value)
	}

	onPasswordChanged (e) {
		this.props.actions.setPasswordInput(e.target.value)
	}

	onTwoFactorCodeChanged (e) {
		this.props.actions.setTwoFactorCode(e.target.value)
	}

	logIn () {
		this.props.loginUser();
	}

	logIn2f () {
		this.props.loginUser2f();
	}

	setShowPassword() {
        this.setState({showPassword: this.state.showPassword ? false : true})
    }

    hover() {
        this.setState({showPassword: true})
    }

    out() {
        this.setState({showPassword: false})
    }

    cancelLogin2f () {
    	this.props.cancelRequest()
    	this.props.actions.setNeedToLogout(true)
    }

    keyUpHandler(refName, e) {
        if (e.keyCode === 13) {
        	if (this.props.login.twoFactorEnabled) {
        		document.getElementById("submit2f").click();
           		document.activeElement.blur()
        	} else {
        		document.getElementById("submit").click();
           		document.activeElement.blur()
        	}
        }
    }

    closeWarning () {
		this.props.actions.setNeedToShowUserWarning("false")
	}

	startTimer() {
	    clearInterval(this.timer);

	    this.timer = setInterval(() => {
	        this.setState(prev => {
	            if (prev.secondsLeft <= 1) {
	                clearInterval(this.timer);
	                this.props.cancelRequest();
	                this.props.actions.setNeedToLogout(true)
	                return { secondsLeft: 0 };
	            }

	            return {
	                secondsLeft: prev.secondsLeft - 1
	            };
	        });
	    }, 1000);
	}

	render() {
		let enableLogin = (this.props.login.login.length > 0 && this.props.login.password.length > 0) ? true : false
		let enable2fLogin = this.props.login.twoFactorCode.length > 5 ? true : false

		if (this.props.login.imageFor2F !== null) {
			const qr = this.props.login.imageFor2F.trim();
			var qrToShow;
	        qrToShow = qr.startsWith("data:")
	            ? qr
	            : `data:image/png;base64,${qr}`
		}

		const TOTAL_SECONDS = this.props.codeTtl;

		const radius = 24;
		const circumference = 2 * Math.PI * radius;

		const progress = this.state.secondsLeft / TOTAL_SECONDS;

		const dashOffset = circumference * (progress - 1);
		
		return (
			<div>
				<div className="row" style={{padding: "0px", backgroundColor: "#f0ebe6"}}>
					<div className="col-4">
						<div className="card col-10" style={{marginTop: "150px"}}>
							<div className="card-body">
								{
									this.props.login.twoFactorEnabled
									? <div>
										<h4 style={{textAlign: "center"}}>{i18next.t("twoFactorPageTitle")}</h4>
										{
											this.props.login.inputTypeFor2F === "image"
											? <div style={{textAlign: "center"}}>
												<img src={qrToShow} style={{
											        width: "256px",
											        height: "256px",
											        display: "block",
											        margin: "0 auto"
											    }} alt="img" />
											    <label style={{fontSize: "14px"}}>{i18next.t("scanQrMessage")}</label>
												<p></p>
												<button id="submit2f" style={{float: "left"}} className="btn btn-info" onClick={this.cancelLogin2f.bind(this)}>{i18next.t("cancelLabel")}</button>
											</div>
											: <div style={{paddingTop: "15px"}}>
												<input type="text" placeholder={i18next.t("oneTimeCodeTitle")} className="form-control" value={this.props.login.twoFactorCode} onChange={this.onTwoFactorCodeChanged} onKeyUp={this.handleOneTimeCodeKeyUp} ref="oneTimeCodeInput" />
												{
						                            this.props.tries !== undefined && this.props.tries > 0
						                            ? <label style={{paddingLeft: "0px", marginBottom: "0px", paddingTop: "10px"}}>{i18next.t("triesLeft")}{this.props.tries}</label>
						                            : null
						                        }
												<p></p>
												<button id="submit2f" className="btn btn-info" disabled={!enable2fLogin} onClick={this.logIn2f.bind(this)}>{i18next.t("signInTitle")}</button>
											</div>
										}
										{
											this.props.codeTtl !== null && this.props.codeTtl !== undefined
											? 
												<div
							                      style={{
							                          position: "absolute",
							                          right: "15px",
							                          bottom: "15px"
							                      }}
							                      >
							                      <svg width="60" height="60">
							                          <circle
							                              cx="30"
							                              cy="30"
							                              r={radius}
							                              fill="none"
							                              stroke="#ddd"
							                              strokeWidth="4"
							                          />

							                          <circle
							                              cx="30"
							                              cy="30"
							                              r={radius}
							                              fill="none"
							                              stroke="#1C92C7"
							                              strokeWidth="4"
							                              strokeLinecap="round"
							                              transform="rotate(-90 30 30)"
							                              strokeDasharray={circumference}
							                              strokeDashoffset={dashOffset}
							                              style={{
							                                  transition: "stroke-dashoffset 0.1s linear"
							                              }}
							                          />

							                          <text
							                              x="30"
							                              y="35"
							                              textAnchor="middle"
							                              fontSize="16"
							                              fontWeight="bold"
							                          >
							                              {this.state.secondsLeft}
							                          </text>
							                      </svg>
							                  </div>
							                  : null
							              }
									</div>
									: <div>
										<h4 style={{paddingBottom: "15px"}}>{i18next.t("loginPageTitle")}</h4>
										<input type="text" placeholder={i18next.t("loginTitle")} className="form-control" value={this.props.login.login} onChange={this.onLoginChanged} />
										<p></p>
										<div className="input-group">
											<input type={this.state.showPassword ? "input" : "password"} placeholder={i18next.t("passwordTitle")} className="form-control" value={this.props.login.password} onChange={this.onPasswordChanged} onKeyUp={this.handlePwdKeyUp} ref="PwdInput" />
										    <div className="input-group-append">
				                                <div className="input-group-text" onClick={this.setShowPassword.bind(this)} onMouseOver={this.hover.bind(this)} onMouseOut={this.out.bind(this)}><i className="fa fa-eye"></i></div>
				                            </div>
				                        </div>
										<p></p>
										<button id="submit" className="btn btn-info" disabled={!enableLogin} onClick={this.logIn.bind(this)}>{i18next.t("signInTitle")}</button>
									</div>
								}
							</div>
						</div>
						{
							this.props.base.needToShowUserWarning === "true"
							? <div className="user-warning card col-10">
								<label className="" style={{marginLeft: "5px", marginTop: "20px", color: "#1C92C7"}}>
									
									<span style={{color: "black", fontSize: "1.5rem", marginLeft: "15px"}}>{i18next.t("warning")}</span>
								</label>
								<ul style={{paddingLeft: "30px", fontSize: "14px", marginBottom: "20px"}}>
									<li>{i18next.t("userWarningFirstLine")}</li>
									<li>{i18next.t("userWarningSecondLine")}</li>
									<li>{i18next.t("userWarningThirdLine")}</li>
								</ul>
							  </div>
							: null
						}
					</div>
					{
						this.props.base.isIEBrowser
						? <div className="FlexItem" style={{padding: "0px"}}>
							<img className="img" src={logo} alt="Logo" />
						</div>
						: <div className="col-8 row-login" style={{padding: "0px"}}>
							<img className="img" src={logo} height="100%" alt="Logo" />
						</div>
					}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    setLoginInput, setPasswordInput,
	    clearLoggedInUserData,
	    setTwoFactorCode, setNeedToShowUserWarning,
	    setNeedToLogout
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);